(() => {
  const root = document.querySelector('[data-premium-product]');
  if (!root) return;
  const app = root.querySelector('[data-size-guide-app]');
  if (!app) return;

  const panels = Array.from(app.querySelectorAll('[data-size-guide-panel]'));
  const viewButtons = Array.from(app.querySelectorAll('[data-size-guide-view]'));
  const unitButtons = Array.from(app.querySelectorAll('[data-size-unit]'));
  const measurementCells = Array.from(app.querySelectorAll('[data-size-measurement]'));

  const showView = (view) => {
    panels.forEach((panel) => {
      const active = panel.dataset.sizeGuidePanel === view;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  };

  viewButtons.forEach((button) => {
    button.addEventListener('click', () => showView(button.dataset.sizeGuideView || 'chart'));
  });

  const formatValue = (inches, unit) => {
    const value = Number(inches);
    if (!Number.isFinite(value)) return inches;
    if (unit === 'cm') return `${(value * 2.54).toFixed(1)} cm`;
    if (unit === 'm') return `${(value * 0.0254).toFixed(2)} m`;
    return `${value % 1 === 0 ? value.toFixed(0) : value} in`;
  };

  const setUnit = (unit) => {
    unitButtons.forEach((button) => {
      const active = button.dataset.sizeUnit === unit;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    measurementCells.forEach((cell) => {
      cell.textContent = formatValue(cell.dataset.inches, unit);
    });
  };

  unitButtons.forEach((button) => button.addEventListener('click', () => setUnit(button.dataset.sizeUnit || 'in')));
  setUnit('in');
  showView('chart');
})();
